export function whatsappDigits(value: string) {
  return value.replace(/\D/g, "");
}

export function whatsappBookingUrl(number: string, lines: string[]) {
  return `https://wa.me/${whatsappDigits(number)}?text=${encodeURIComponent(lines.join("\n"))}`;
}

export function formatProductNo(productNo: number) {
  return `#${productNo}`;
}

export function formatInr(cents: number) {
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(cents / 100);
}

export function formatPrice(cents: number) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(cents / 100);
}

export function formatDuration(minutes: number) {
  if (minutes < 60) return `${minutes} min`;
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  if (rest === 0) return `${hours} hr`;
  return `${hours} hr ${rest} min`;
}
